import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Axios from "axios";
import JwtDecode from "jwt-decode";

import Paypal from "../../../utils/Paypal/Paypal";
import { url } from "../../../config/config";

const useStyles = (theme) => ({
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 350,
    },
  },
  rootContent: {
    width: 500,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      paddingTop: 0,
      paddingLeft: 0,
    },
  },
  contentStyle: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: 0,
    },
  },
  priceStyle: {
    display: "flex",
    width: "30%",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      width: "70%",
    },
  },
  cancelButtonStyle: {
    "&:hover": {
      backkgroundColor: "transparent",
    },
  },
  payButtonStyle: {
    outline: "none",
    variant: "contained",
    color: "#ffffff",
    backgroundColor: "blue !important",
    outlineColor: "blue !important",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
});

class CartDialogBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        orderId: sessionStorage.getItem("orderId"),
        bookCoverUrl: "",
        title: "",
        author: "",
        price: "",
      },
      userData: [],
      usdCurrency: 0,
      transactionSuccess: false,
    };
  }

  componentDidMount() {
    this.getCurrency();
    this.decodeData(this.props.userToken);
  }

  decodeData = (userToken) => {
    try {
      const decoded = JwtDecode(userToken);
      this.setState({
        userData: decoded,
      });
    } catch (err) {}
  };

  getCurrency = async () => {
    const response = await Axios.get("https://api.exchangerate.host/latest", {
      params: {
        base: "NPR",
      },
    });
    this.setState({
      usdCurrency: response.data.rates.USD,
    });
  };

  transactionSuccess = async (paymentData) => {
    let newArray = this.props.book.map((book) => {
      return {
        bookId: book.id._id,
        title: book.id.title,
        price: book.id.price,
      };
    });
    let data = {
      orderId: this.state.data.orderId,
      payVia: this.props.payType,
      paypalEmail: paymentData.email,
      paymentId: paymentData.paymentID,
      totalPrice:
        this.props.payType === "esewa"
          ? this.props.totalPrice
          : this.props.changedCurrency,
      itemDetails: newArray,
    };
    const response = await Axios.post(`${url}/api/sold`, data, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.success) {
      this.props.clearCart();
    }
  };

  transactionError = () => {
    console.log("Paypal error");
  };

  transactionCanceled = () => {
    console.log("Transaction canceled");
  };

  render() {
    const { classes, payType, book } = this.props;
    const { data } = this.state;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        style={{ fontFamily: "Open Sans", fontSize: 20 }}
      >
        <DialogTitle>OrderId: {data.orderId}</DialogTitle>
        <DialogContent className={classes.rootContent}>
          {book.map((book, index) => (
            <div key={index} className={classes.contentStyle}>
              <h4 style={{ width: "70%" }}>{book.id.title}</h4>
              {payType === "esewa" ? (
                <div className={classes.priceStyle}>
                  Price: Rs.{book.id.price}
                </div>
              ) : (
                <div className={classes.priceStyle}>
                  Price: ${" "}
                  {Math.round(book.id.price * this.state.usdCurrency * 100) /
                    100}
                </div>
              )}
            </div>
          ))}
        </DialogContent>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {payType === "esewa" ? (
            <b>Total Price: Rs.{this.props.totalPrice}</b>
          ) : (
            <b>Total Price: ${this.props.changedCurrency}</b>
          )}
        </div>
        <DialogActions>
          <Button
            variant="contained"
            disableRipple
            className={classes.cancelButtonStyle}
            onClick={this.props.handleClose}
          >
            Cancel
          </Button>
          {this.props.payType === "esewa" ? (
            <Button
              variant="contained"
              disableRipple
              className={classes.payButtonStyle}
            >
              pay
            </Button>
          ) : (
            this.props.changedCurrency > 0 && (
              <Paypal
                totalPrice={this.props.changedCurrency}
                onSuccess={this.transactionSuccess}
                transactionError={this.transactionError}
                transactionCanceled={this.transactionCanceled}
              />
            )
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(CartDialogBox)));
